export interface Client {
    [key: string]: any;
    id?: number;
    suchname?: string;
    zakenn?: string;
    name1?: string;
    name2?: string;
    strasse?: string;
    land?: string;
    plz?: string;
    ort?: string;
    telefon1?: string;
    telefon2?: any;
    telefon3?: any;
    email?: string;
    web?: string;
    erf_von?: any;
    erf_am?: any;
    korr_von?: string;
    nummer?: string;
    uidnr?: string;
    kontakt?: any;
    wartung?: string;
    memo1?: string;
    steuerfrei?: string;
    xuser_roles?: string;
    xvpartner?: string;
    anwendername?: string;
    lizenznamen?: string[];
    lizenzart?: string;
    einzelplatzlizenzNr?: string
    xversion?: string
    xgueltigvon?: string
    xgueltigbis?: string
    xkukennwort?: string
    wartungsvertrag?: string
    xdomainakt?: string
    ablaufdatum?: string
    emailERechnung?: string
    firmenbuchnummer?: string
    enabled?: boolean;
    password?: string;
    accountNonExpired?: boolean;
    credentialsNonExpired?: boolean;
    accountNonLocked?: boolean;
    username?: string;
    authorities?: string[];
}

export interface PC {
    number: string;
    comment: string;
    activationDate: string;
}

export enum clientFields {
    name1 = "name1",
    name2 = "name2",
    strasse = "strasse",
    land = "land",
    plz = "plz",
    ort = "ort",
    telefon1 = "telefon1",
    telefon2 = "telefon2",
    telefon3 = "telefon3",
    email = "email",
    web = "web",
    uidnr = "uidnr",
    emailERechnung = "emailERechnung",
    firmenbuchnummer = "firmenbuchnummer",
    lizenzierteVersion = "lizenzierteVersion"
}
